export const searchReportTemplate = [
  { header: 'searchReport.items.name' },
  { header: 'searchReport.items.action' },
  { header: 'searchReport.items.active' },
  { header: 'searchReport.items.test' },
  { header: 'searchReport.items.type' },
  { header: 'searchReport.items.version' },
  { header: 'searchReport.items.date' },
  { header: 'searchReport.items.user' },
  { header: 'searchReport.items.email' },
]
